module.exports = __webpack_public_path__ + "static/img/2020.fefd5dd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/2020.jpg
// module id = PQjY
// module chunks = 1